export default "__VITE_ASSET__DD802$bP__"